<template>
	<div class="view transaction-view">
		<HeaderBar />
		<ul class="transaction-wrap"
			v-infinite-scroll="loadMore"
			:infinite-scroll-disabled="bottomLoading">
			<li class="transaction-item"
				v-for="(item, index) in list"
				:key="index">
				<div class="left">
					<div class="title">{{ item.title }}</div>
					<span class="text--sub">{{ item.create_date }}</span>
				</div>
				<div class="right"
					 :class="{'is-positive': item.sign !== '-'}">
					{{ `${item.sign}${item.point.toFixed(2)}` }}
				</div>
			</li>
			<div class="no-msg text--sub"
				 v-if="isNoContent">——— 暂无纪录 ———</div>
		</ul>

	</div>
</template>

<script>
import HeaderBar from '../../components/HeaderBar';
import apiConst from '../../consts/apiConst';
import apiUtil from '../../utils/apiUtil';
export default {
	name: 'transaction',
	components: {
		HeaderBar
	},
	data() {
		return {
			bottomLoading: false,
			page: 1,
			loadFinished: false,
			list: [],
			isNoContent: false,
			firstLoaded: false
		};
	},
	created() {
		this.init();
	},
	methods: {
		loadMore() {
			if (!this.loadFinished && this.firstLoaded) {
				this.init(this.page + 1, 10);
			}
		},
		async init(page = 1, pagesize = 10) {
			const res = await apiUtil.post(apiConst.getTransaction, { page, pagesize });
			if (res.success) {
				this.firstLoaded = true;
				this.list = this.list.concat(res.list);
				this.page = page;
				if (res.list.length === 0) {
					this.isNoContent = true;
				}
				if (res.list.length < pagesize) {
					this.loadFinished = true;
				}
			}

		}
	}
};
</script>
<style lang="stylus" scoped>
.transaction-view {
	padding-top: 110px;
	height: 100%;

	.transaction-wrap {
		height: 100%;
		overflow-y: auto;
		padding: 30px 15px;
		-webkit-overflow-scrolling: touch

		.transaction-item {
			display: flex;
			align-items: center;
			height: 158px;
			justify-content: space-between;
			padding: 0 38px;
			border-bottom: 1PX solid #f1f1f1;

			.left {
				.title {
					font-weight: bold;
					font-size: 32px;
					margin-bottom: 24px;
				}

				.text--sub {
					font-size: 30px;
				}
			}

			.right {
				font-size: 50px;
				color: #333;

				&.is-positive {
					color: #8FC31E;
				}
			}
		}

		.no-msg {
			text-align: center;
			padding: 20px;
		}
	}
}
</style>
